import { rootReducer } from './root-reducer';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';
import {
  AnyAction,
  AsyncThunkPayloadCreator,
  Dispatch,
  PreloadedState,
  configureStore,
  createAsyncThunk,
} from '@reduxjs/toolkit';
import { RootState } from '../domain/models/RootState';
import { initialStateWarehouses } from './warehouses/slice';
import { initialStateUsers } from './users/slice';
import { initialStateDashboard } from './dashboard/slice';
import { initialStateTypeKeys } from './typekeys/slice';
import { initialStateDrawers } from './drawers/slice';
import { initialStateHousekeys } from './housekeys/slice';
import { initialStateProperties } from './properties/slice';
import { initialStateDrawersDivisions } from './drawersdivisions/slice';
import { initialStateLoans } from './loans/slice';
import { initialStateLoansP2P } from './loans_p2p/slice';
import { initialStateLoansP2PKey } from './loans_p2p_key/slice';
import { initialStateScan } from './scan/slice';
import { initialStateRenovation } from './renovation/slice';
import { initialStateAuth } from './auth/slice';
import { initialStateHousekeyComments } from './housekeys_comments/slice';
import { initialStateTimeZones } from './time_zones/slice';
import { initialStateReturns } from './returns/slice';

const middleware: any[] = [];
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth'],
};

export const preloadedState: RootState = {
  dashboard: initialStateDashboard,
  warehouses: initialStateWarehouses,
  drawers: initialStateDrawers,
  housekeys: initialStateHousekeys,
  housekey_comments: initialStateHousekeyComments,
  type_keys: initialStateTypeKeys,
  properties: initialStateProperties,
  drawers_divisions: initialStateDrawersDivisions,
  users: initialStateUsers,
  loans: initialStateLoans,
  loans_p2p: initialStateLoansP2P,
  loans_p2p_key: initialStateLoansP2PKey,
  scan: initialStateScan,
  renovation: initialStateRenovation,
  auth: initialStateAuth,
  timeZones: initialStateTimeZones,
  returns: initialStateReturns,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
export const setupStore = (state?: PreloadedState<RootState>) =>
  configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        immutableCheck: false,
        serializableCheck: false,
      }).concat(middleware),
    devTools: process.env.NODE_ENV !== 'production',
  });
export const store = setupStore(preloadedState);
